var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"title":"订单详情","width":800},model:{value:(_vm.config),callback:function ($$v) {_vm.config=$$v},expression:"config"}},[_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }